<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch5">
<div class="chapterHead"><p class="centerImage0"><img alt="image" src="images/ch5.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;">Nervously, you and Liz step down from the tubes. You glance around for Jake. But you don’t see him anywhere.</p>
<p class="para" style="text-indent: 5%;">Where is that voice coming from? you wonder. Then you spot two speakers hanging from wires on the cavelike walls.</p>
<p class="para" style="text-indent: 5%;">“There’s no one here,” Liz whispers.</p>
<p class="para" style="text-indent: 5%;">A few steps away, you see two bucket seats lined with cushions. Two comfortable chairs just sitting there in the middle of the cave. Without thinking, you and Liz fall into the soft, cushioned seats to collect your thoughts.</p>
<p class="para" style="text-indent: 5%;">“We’ve lost Jake.” You state the obvious. “If only we could find Mr. Dunning and the group!”</p>
<p class="para" style="text-indent: 5%;">“What kind of weird wax museum is this, anyway? There’s something terrible happening here,” Liz says.</p>
<p class="para" style="text-indent: 5%;">Another recorded message suddenly blares through the cavern: “<em class="italic">For the convenience of other visitors, please keep moving</em> …”</p>
<p class="para" style="text-indent: 5%;">Then the floor beneath your seats starts to move. Just like the test tubes. “Hey!” you shout, trying to get up.</p>
<p class="para" style="text-indent: 5%;">A bar falls down across your lap. Another drops down on Liz.</p>
<p class="para" style="text-indent: 5%;">Wait a minute, you think. You’ve been in seats like these before. At the amusement park! You must have stumbled onto some sort of wax museum ride. Hope it’s a good one!</p>
<p class="extractLetterText" style="text-indent: 5%;"><em class="italic">Hang on as you ride over to <span href="#/e9780545841733_ch049" title="Link target outside of Sample">PAGE 49</span>.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545841733_ch005.vue?13d7cc06